import { render, staticRenderFns } from "./RejectionInformation.vue?vue&type=template&id=6d8ba590&scoped=true&"
import script from "./RejectionInformation.vue?vue&type=script&lang=ts&"
export * from "./RejectionInformation.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionInformation.vue?vue&type=style&index=0&id=6d8ba590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ba590",
  null
  
)

export default component.exports